import {useState,useEffect,useMemo} from 'react';
import styles from '../Applicants/css/display-applicant.module.css';
import { useQuery } from '@tanstack/react-query';
import {FilterDropDown} from '../Applicants/Applicants'; 
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import apiCall from '../../../utils/apiCall';
import { CircularProgress, styled } from '@mui/material';
import { AxiosError } from 'axios';
import ApplicantTable from './ApplicantTable';
import {ExNyRoute, PrRoute, ExRoute, AcRoute, MiRoute, CoRoute} from '../../../utils/allRouteId'
import {RouteResponse} from '../../../types/index'
  import {FetchAllRoutes, reOrderFetchedData} from '../../../hooks/FetchData'




interface Applicants {
  ApplicantId: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Email: string;
  PhoneNumber: string;
  ContactAddress: string;
  Gender: string;
  Disablity?: any;
  IsSubmitted: boolean;
  RouteId: number;
  Title: string;
  BirthDate: string;
  WhatsAppNumber?: any;
  PhotoUrl: string;
  RouteName: string;
}

interface DisplayApplicantsProps  {
  setRouteName: React.Dispatch<React.SetStateAction<string>>
}


const option1:any= [
    // {val:1, name:"Memembership Route",path:`${BASE_URL}`},
     {val: ExNyRoute, name:"Examination / NYSC"},
    {val:PrRoute, name:"Practitioner"},
    {val:ExRoute, name:"Executive"},
    {val: AcRoute, name:"Academic"},
    {val: MiRoute, name:"Military"},
    {val:CoRoute, name:"Corporate"}
  ]

  const option2:any = [
    {val:1,name:"Pending Approval"},
    {val:2,name:"Approved"}
  ]
  
  export const option3:any = [
    {val:1,name:"Application"},
    {val:2,name:"Membership"}
  ]
  


const DisplayApplicant = ({setRouteName}: DisplayApplicantsProps) =>{
    const [opt2,setOpt2] = useState<any>([...option2]);
    const optb = useMemo(()=>opt2,[opt2]);
    const [routeId, setRouteId] = useState<number>(Number(ExRoute));
    const [statusF,setStatusF] = useState<any>('');
    const [searchData, setSearchData] = useState('');
    const [routeNameInt, setRouteNameInt] = useState('')


    
      

    const getAllApplicants = async (): Promise<Applicants[]>=> {
        return (await apiCall().get(`/Applicant/GetAllApplicant?RouteId=${routeId}`))?.data?.Data;
    }

    const {isLoading, data} = FetchAllRoutes();

    const reOrderedAllRoutes = data ? reOrderFetchedData((data as RouteResponse )?.Data) : []

    const allRoutes = isLoading ? [] : reOrderedAllRoutes.map((item) => {return {name: item?.RouteName, val: item?.RouteId}})

    const getAllApplicantsQuery = useQuery([`get-All-Applicant ${routeId}`, searchData], getAllApplicants, {retry: 0, refetchOnWindowFocus: false} )


    const getAllApplicantsData = getAllApplicantsQuery?.data;
    const getAllApplicantsError = getAllApplicantsQuery?.error as AxiosError;

    const switchRouteId = (route: {val: number, name: string}) => {
        setRouteId(route?.val);
        setRouteName(route?.name);
        setRouteNameInt(route?.name);
    }

    const filteredData = getAllApplicantsData?.filter(x => (
      Object.values(x).join("").toLowerCase().includes(searchData.toLowerCase())
    ));

    return (     
        <div className={styles.container}>
            <div className={styles.filterDiv}>
            <label className={styles.searchForm} ><span className={styles.sI}><SearchIcon/></span><input type="text" placeholder='Search' value={searchData} onChange={e => setSearchData(e.target.value) }/><button className={styles.rBtn} type="submit"><ReloadIcon/></button></label>
            <FilterDropDown onChange={switchRouteId} text={routeNameInt ? `${routeNameInt}` : 'Membership Route'} bg="#0A3922" color="#fff" options={allRoutes} />
            <FilterDropDown onChange={setStatusF} text="Status" bg="#E2E4E9" options={opt2} />
            </div>
            <div>
                {getAllApplicantsQuery?.isFetching ? (
                    <CircularProgress 
                        sx={{
                        fontSize: '1rem',
                        marginInline: 'auto',
                        display: 'block',
                        marginBlock: '2rem'
                        }}
                    />
                ) : getAllApplicantsQuery.isError ? (
                    <StyledError>{getAllApplicantsError?.message}</StyledError>
                ) : filteredData && filteredData?.length > 0 ? 
                <ApplicantTable data={searchData.length > 0 ? filteredData : getAllApplicantsData} />
                : <NoResult>No Results</NoResult>}
            </div>
        </div>
    )
  }


  export default DisplayApplicant


  const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`

const NoResult = styled('div')`
  margin-block-start: 0px;
`